import Vue from 'vue'
import Meta from 'vue-meta'
import vuetify from '@/libs/vuetify'
import * as errors from '@/libs/errors'
import store from './store'
import router from './router'
import VueGtag from 'vue-gtag'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import '@/libs/vuetify/styles/bookin.scss'
import App from './pages/App'

Vue.config.productionTip = false
Vue.use(Meta)
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_ID }
}, router)

//
// error handler
//
errors.setHandler(errs => {
  store.commit('stateAddErrors', errs)
})

//
// disabled v-calendar warning
//
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.'
Vue.config.warnHandler = function (msg, vm, trace) {
  if (msg === ignoreWarnMessage && (trace || '').indexOf('<VCalendarMonthly>') >= 0) {
    msg = null
    vm = null
    trace = null
  }
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
